<template>
  <div class="container">
    <div class="main">
      <div v-for="(item, index) in hzTopicList" :key="index" class="box">
        <div class="title">{{ index + 1 }}. &nbsp;&nbsp;{{ item.topicTitle }}</div>
        <div v-if="item.topicStatus == '2'">
          <el-checkbox-group v-model="checkList" class="checkBox">
            <el-checkbox v-for="item in split(item.topicContent)" :label="item" :key="item"></el-checkbox>
          </el-checkbox-group>
          <div class="other">
            <el-checkbox :label="$t('person.quest.other')" v-model="other[index].checked" @change="handle(other[index])"></el-checkbox>
            <el-input v-model="other[index].string" :disabled="other[index].disabled" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div v-else>
          <el-radio-group v-model="radioInitValue.filter((it) => it.length == split(item.topicContent).length)[0].name" @change="changeRadio(item)">
            <el-radio :label="i" v-for="i in split(item.topicContent)" :key="i"></el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="submit" @click="submit()">{{ $t('common.submit') }}</div>
  </div>
</template>
<script>
import { getQuest, submitQuest } from '../../../../api/personInfo.js';
export default {
  data() {
    return {
      radioInitValue: [
        { length: 2, name: '' },
        { length: 4, name: '' },
      ],
      checkList: [],
      radio: [],
      hzTopicList: [],
      hzAudienceTopic: [],
      value: {},
      check: {},
      topic: [],
      badgeMsg: false, //是否显示红点
      other: [],
      initValue: [],
    };
  },
  created() {
    this.getInfo();
  },

  methods: {
    changeRadio(item) {
      this.radioInitValue.map((it) => {
        if (this.split(item.topicContent).length == it.length) {
          if (this.initValue.length == 0) {
            this.initValue.push({ name: it.name, id: item.id });
          } else {
            //  判断是修改还是增加
            var current = this.initValue.filter((i) => i.id == item.id);
            if (current.length == 0) {
              this.initValue.push({ name: it.name, id: item.id });
            } else {
              this.initValue.map((i) => {
                if (i.id == item.id) {
                  i.name = it.name;
                }
              });
            }
          }
        }
      });
    },
    handle(val) {
      if (val.checked == false) {
        val.string = '';
      }
    },
    async save(params) {
      try {
        const { data } = await submitQuest(params);
        if (data.code === 200) {
          this.getInfo();
        }
      } catch (err) {
        console.log(err.message);
      }
    },
    submit() {
      this.topic = [];
      // 正常的复选框
      const arr = this.hzTopicList;
      arr.map((item) => {
        const currentContent = item.topicContent.split(',');
        this.checkList.map((it) => {
          if (currentContent.includes(it)) {
            this.topic.push(item.id + '_' + it);
          }
        });
      });
      // 其他的复选框
      const result = this.other.filter((it) => it.string.length > 0);
      result.map((it) => {
        this.topic.push(it.id + '_other==' + it.string);
      });
      // 单选框
      if (this.initValue.length !== 0) {
        this.initValue.map((it) => {
          this.topic.push(it.id + '_' + it.name);
        });
      }
      // 提交函数

      this.topic = Array.from(new Set(this.topic));
      const params = {
        topic: this.topic,
      };
      this.save(params);
    },

    split(string) {
      const arr = string.split(',');
      return arr;
    },

    init() {
      this.hzTopicList.map((item) => {
        this.hzAudienceTopic.map((it) => {
          if (item.topicStatus == '2' && item.id == it.id) {
            // 当前已经选择的题目和当前多选的交集
            this.checkList.push(it.name);
          } else if (item.topicStatus == '1' && item.id == it.id) {
            this.radioInitValue.map((i) => {
              if (i.length == this.split(item.topicContent).length) {
                i.name = it.name;
                this.initValue.push({ name: it.name, id: it.id });
              }
            });
          }
        });
      });
    },

    setInitOther() {
      // this.hzAudienceTopic; //已经选择的题目
      const result = this.hzAudienceTopic.filter((it) => it.name.includes('other'));
      // 遍历所有other的 通过id和 other对象里面的id匹配并修改当前 other里面的内容
      result.map((item) => {
        this.other.map((it) => {
          if (it.id === item.id) {
            it.string = item.name.slice(7);
            it.checked = true;
          }
        });
      });
    },
    async getInfo() {
      try {
        const { data } = await getQuest();
        if (data.code === 200) {
          this.hzTopicList = data.data.hzTopicList;
          this.hzAudienceTopic = data.data.hzAudienceTopic; //已选的题目
          //9组题循环，other里面9个key，顺序和hzTopicList
          this.hzTopicList.map((item) => {
            this.other.push({ id: item.id, string: '', checked: false });
          });
          this.setInitOther();
          //处理其他已选中的状态
          this.init();
          //判断已选题目的数量,如果已选题目的数量小于问卷题目的数量,说明有题目没作答,设置为true,显示红点
          this.hzAudienceTopic.length < 9 ? (this.badgeMsg = true) : (this.badgeMsg = false);
          this.$emit('func', this.badgeMsg);
        }
      } catch (err) {
        console.log(err.message);
      }
    },
  },
  watch: {
    other: {
      handler(newValue, oldValue) {
        for (let i = 0; i < newValue.length; i++) {
          if (newValue[i].checked == true) {
            newValue[i].disabled = false;
          } else {
            newValue[i].disabled = true;
          }
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  margin: 0 auto;
  width: 93%;
  .main {
    margin-top: 40px;
    .title {
      margin-top: 40px;
    }
    .other {
      display: flex;
    }
  }
  .submit {
    text-align: center;
    width: 88px;
    height: 32px;
    background: #006fb8;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 32px;
    margin-top: 36px;
  }
  .submit:hover {
    cursor: pointer;
  }
}
</style>
<style scoped>
.el-checkbox {
  width: 20%;
  /* margin-left: 80px; */
  margin-top: 20px;
}

.el-input >>> .el-input__inner {
  width: 180px;
  height: 32px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  margin-left: -30px;
  margin-top: 13px;
}
.el-checkbox >>> .el-checkbox__label {
  white-space: normal;
  vertical-align: text-top;
}
.el-radio-group {
  width: 100%;
}
.el-radio-group >>> .el-radio {
  width: 20%;
  margin-top: 20px;
}
</style>
